export default {
	macos: 'https://examview-student.com/installer/ExamView_Student_macos_latest.dmg',
	windows: 'https://examview-student.com/installer/ExamView_Student_win_latest.exe',
	ios: 'https://itunes.apple.com/us/app/examview-student-phone/id1157548238?ls=1&mt=8',
	android: 'https://play.google.com/store/apps/details?id=com.turningtechnologies.vpad.examview'
};
